"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Toolbar = exports.Dialog = exports.Container = exports.CarouselWrapper = void 0;
var _components = require("@ori-ui/components");
var _mui = require("@ori-ui/mui");
var _presentationComponents = require("@ori/presentation-components");
var _presentationProductDetail = require("@ori/presentation-product-detail");
var _presentationUtils = require("@ori/presentation-utils");
const Container = exports.Container = (0, _mui.styled)('div')({
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
  justifyContent: 'end',
  width: '100%'
});
const Dialog = exports.Dialog = (0, _mui.styled)(_components.Dialog)({
  [`.${_components.dialogClasses.dialogGrid}`]: {
    height: '90%',
    maxHeight: 758,
    maxWidth: 1053,
    padding: 0,
    width: '90%'
  },
  [`.${_components.dialogClasses.content}`]: {
    overflow: 'unset',
    padding: 0
  }
});
const Toolbar = exports.Toolbar = (0, _mui.styled)('div')(({
  theme
}) => ({
  order: 1,
  height: 86,
  padding: theme.spacing(3, 3, 6),
  [theme.breakpoints.up('sm')]: {
    height: 81,
    padding: theme.spacing(4, 2)
  }
}));
const NAVIGATION_ARROW_WIDTH = 39;
const CarouselWrapper = exports.CarouselWrapper = (0, _mui.styled)('div', {
  shouldForwardProp: (0, _presentationUtils.shouldForwardProp)()
})(({
  numberOfSlides
}) => ({
  display: 'flex',
  justifyContent: 'center',
  width: '100%',
  [`& .${_presentationComponents.carouselClasses.root}`]: {
    margin: 0,
    maxWidth: `calc(${numberOfSlides * _presentationComponents.SHADES_SIZE_CURRENT}px + ${_presentationProductDetail.SPACING * numberOfSlides}px + ${2 * NAVIGATION_ARROW_WIDTH}px)`,
    width: '100%'
  },
  [`& .${_presentationComponents.shadeClasses.root}`]: {
    boxSizing: 'content-box'
  }
}));
